<template>
  <BaseSelect
    v-model="selectValue"
    select-type="v-autocomplete"
    :items="filteredItems"
    v-bind="{ ...$attrs, ...$props, ...$listeners }"
    :return-object="true"
    @input="$emit('input', $event)"
    @change="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  />
</template>

<script>
//    <BaseAlert v-else type="warning" :message="$t('complaintForm.ticket.engine.notavailable')" />
import { isUndefined } from 'lodash-es'
import EngineArticleNumberMixin from './engine-article-number-mixin.js'

export default {
  name: 'EngineArticleNumberCB',
  mixins: [EngineArticleNumberMixin],
  props: {
    modelType: {
      type: String,
      default: undefined,
    },
    orderType: {
      type: String,
      default: undefined,
    },
    calculationDesire: {
      type: String,
      default: undefined,
    },
    withLegacyDevicePickUp: {
      type: Boolean,
      default: undefined,
    },
    engineType: {
      type: String,
      default: undefined,
    },
    repairProcessType: {
      type: [String, Number],
      default: undefined,
    },
    hideDetails: {
      type: [Boolean, String],
      default: undefined,
    },
    errorMessages: {
      type: [String, Array],
      default: () => [],
    },
    value: {
      type: [String, Array, Object],
      default: undefined,
    },
    addLegacyEngines: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectValue: undefined,
    }
  },
  computed: {
    modelTypeDataKey() {
      return this.getModelTypeDataKey(this.modelType, this.allModelTypeKeys)
    },
    filteredItems() {
      return this.getFilteredItems(
        this.modelTypeDataKey,
        this.engineType,
        this.repairProcessType,
        this.addLegacyEngines,
        this.calculationDesire,
      )
    },
  },
  watch: {
    filteredItems() {
      if (
        !(isUndefined(this.selectValue) && this.filteredItems.length && this.$route.query?.motorKey)
      ) {
        return
      }
      const item = this.filteredItems.find(item => item.value === this.$route.query?.motorKey)
      if (!item) {
        return
      }
      this.selectValue = item
      this.$emit('input', item)
    },
  },
}
</script>
